"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToHilDifferentialPair = mapToHilDifferentialPair;
exports.mapFromHilDifferentialPair = mapFromHilDifferentialPair;
function mapToHilDifferentialPair(differentialPair) {
    return {
        id: differentialPair.pairName,
        name: differentialPair.pairName,
        positiveSignalId: typeof differentialPair.positiveId === 'number' ?
            String(differentialPair.positiveId)
            : differentialPair.positiveId,
        negativeSignalId: typeof differentialPair.negativeId === 'number' ?
            String(differentialPair.negativeId)
            : differentialPair.negativeId,
    };
}
function mapFromHilDifferentialPair(differentialPair) {
    return {
        pairName: differentialPair.name,
        positiveId: differentialPair.positiveSignalId ?? '',
        negativeId: differentialPair.negativeSignalId ?? '',
    };
}
//# sourceMappingURL=differential-pair.mapper.js.map